import React from 'react';
import { BrowserRouter as Router, Route , Switch } from 'react-router-dom';

import NavBar from './Shared/NavBar.js';
import SocialLinks from './Shared/SocialLinks.js';

import Lab from './Pages/Lab.js';
import Home from './Pages/Home.js';
import Work from './Pages/Work.js';
import Goals from './Pages/Goals.js';
import Skills from './Pages/Skills.js';
import NoMatch from './Pages/NoMatch.js';
import Experience from './Pages/Experience.js';

import './App.css';

class App extends React.Component {
  render() {
    return (
      <Router>
        <div className="app-wrapper app-wrapper--dark">
          <i className="app-stars app-stars-1" />
          <i className="app-stars app-stars-2" />

          <header className="app-header">
            <a className="app-header-logo" href={'/'}>Im Umar</a>

            <SocialLinks />
            <NavBar />
          </header>

          <Switch>
            <Route exact path="/" component={ Home } />
            <Route path="/Work" component={ Work } />
            <Route path="/Skills" component={ Skills } />
            <Route path="/Experience" component={ Experience } />
            <Route path="/Lab" component={ Lab } />
            <Route path="/Goals" component={ Goals } />

            <Route component={ NoMatch } />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js